import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=41eedcec&lang=less&scoped=true"

import exportComponent from "/Volumes/Mac_SSD/work_desktop/old-im/webapp-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41eedcec"]])

export default __exports__